
export const GA_EVENT_CATEGORY = 'Multi Address'
export const REQUIRED_SELECTION = 'Please select an address'

export default REQUIRED_SELECTION



// WEBPACK FOOTER //
// ./containers/stages/MultipleAddressStage/constants.js